import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Estimation } from '../../models/estimation.model';
import { ProjectsList } from '../../models/projects.model';
import { Provider } from '../../models/provider.model';

@Component({
  selector: 'app-create-estimation-drawer',
  templateUrl: './create-estimation-drawer.component.html',
  styleUrl: './create-estimation-drawer.component.scss',
})
export class CreateEstimationDrawerComponent {
  @Input() showEstimationDrawer = false;
  @Input() projects: any[] = [];
  @Input() selectedProject?: ProjectsList | 'all';
  @Input() companies: any[] = [];
  @Input() providers: any[] = [];
  @Input() types: any[] = [];

  @Output() closeDrawer = new EventEmitter<void>();
  @Output() searchProjects = new EventEmitter<string>();
  @Output() searchProviders = new EventEmitter<string>();
  @Output() createEstimation = new EventEmitter<Estimation>();

  createEstimationForm: any;
  unassignedProjectId = 9;
  selectedProvider!: Provider;

  constructor(private fb: FormBuilder) {
    this.createEstimationForm = this.fb.group({
      project: ['', [Validators.required, Validators.minLength(2)]],
      company: [{ value: '', disabled: true }],
      provider: ['', [Validators.required, Validators.minLength(2)]],
      type: [null, [Validators.required, Validators.min(0)]],
      description: ['', [Validators.required, Validators.minLength(1)]],
    });
  }

  ngOnChanges(): void {
    this.createEstimationForm.patchValue({
      project:
        this.selectedProject === 'all'
          ? 'all'
          : this.selectedProject?.projectName || '',
    });
    this.createEstimationForm.patchValue({
      company:
        this.selectedProject && this.selectedProject !== 'all'
          ? this.selectedProject?.projectCompany
          : '',
    });
  }

  close() {
    this.closeDrawer.emit();
    this.createEstimationForm.reset();
  }

  onCreateEstimation() {
    this.createEstimation.emit({
      ...this.createEstimationForm.value,
      projectID:
        this.selectedProject !== 'all' ? this.selectedProject!.projectId : null,
      supplierID: this.selectedProvider.id,
    });
  }

  onSearchProject(event: any) {
    if (!event) return;
    this.searchProjects.emit(event.target.value);
  }

  onSelectProject(e: any) {
    if (!e) return;
    this.selectedProject = e.nzValue as ProjectsList;
    if (this.selectedProject?.projectCompanyId === this.unassignedProjectId) {
      this.createEstimationForm.controls.company.enable();
    } else {
      this.createEstimationForm.controls.company.disable();
      this.createEstimationForm.patchValue({
        company: this.selectedProject?.projectCompany,
      });
    }
  }

  onSearchProvider(event: any) {
    if (!event) return;
    this.searchProviders.emit(event.target.value);
  }

  onSelectProvider(e: any) {
    if (!e) return;
    this.selectedProvider = e.nzValue as Provider;
    this.createEstimationForm.patchValue({
      provider: this.selectedProvider.providerLegalName,
    });
  }
}
